<section class="content">
  <div class="content-block">
    <div class="block-header">
      <app-breadcrumb [items]="[{ label: 'PACIENTES', link: '/patient/patient-list' }, { label: 'PERFIL DEL PACIENTE' }]"></app-breadcrumb>
    </div>

    <div class="row clearfix">
      <!-- ===== COLUMNA IZQUIERDA ===== -->
      <div class="col-lg-4 col-md-12">
        <!-- ===== PERFIL PACIENTE ===== -->
        <div class="card card-patient-profile">
          <div class="profile-content">
            <img *ngIf="userImage; else pacienteIcon" class="profile-img profile-img--xl" [src]="userImage" alt="Foto del Paciente" />

            <ng-template #pacienteIcon>
              <img class="profile-img profile-img--xl" src="assets/images/paciente.png" alt="Paciente" />
            </ng-template>

            <div class="profile-text">
              <div class="profile-name">{{ patient.nombres }} {{ patient.primerApellido }}</div>
              <div class="profile-subtext">{{ 'SUCURSAL' | regionWord }}: {{ patient.sucursal }}</div>
            </div>
          </div>
        </div>

        <!-- ===== Tarjeta del tutor (si el paciente tiene tutor) ===== -->
        <div class="card card-tutor-profile" *ngIf="tutor">
          <div class="tutor-header">
            <div class="tutor-header-left">
              <img
                class="avatar avatar--md"
                [src]="tutorImage || 'assets/images/paciente.png'"
                alt="Foto del Tutor"
              />

              <div class="tutor-text">
                <div class="tutor-name-header">
                  {{ tutor.nombres }} {{ tutor.primerApellido }} {{ tutor.segundoApellido }}
                </div>
                <div class="tutor-subtext">TUTOR DEL PACIENTE</div>
              </div>
            </div>

            <!-- ✅ ACCIONES -->
            <div class="tutor-header-actions">
              <button
                mat-stroked-button
                type="button"
                class="btn-header"
                (click)="cambiarTutor()"
                matTooltip="CAMBIAR TUTOR"
                matTooltipPosition="above">
                <mat-icon>sync_alt</mat-icon>
                CAMBIAR
              </button>

              <button
                mat-stroked-button
                color="warn"
                type="button"
                class="btn-header"
                (click)="eliminarTutor()"
                matTooltip="ELIMINAR TUTOR"
                matTooltipPosition="above">
                <mat-icon>person_remove</mat-icon>
                ELIMINAR
              </button>
            </div>
          </div>

          <div class="card-body">
            <ul class="tutor-details">
              <li><mat-icon>email</mat-icon><span class="break-anywhere">{{ tutor.email }}</span></li>
              <li><mat-icon>phone</mat-icon><span>{{ tutor.movil | formatMobile }}</span></li>
              <li><mat-icon>cake</mat-icon><span>{{ tutor.fechaNacimiento | date:'yyyy-MM-dd' }}</span></li>
              <li><mat-icon>location_on</mat-icon><span>{{ tutor.domicilio }}</span></li>
            </ul>
          </div>
        </div>
      </div>

      <!-- ===== COLUMNA DERECHA ===== -->
      <div class="col-lg-8 col-md-12">
        <mat-accordion multi="true" class="details-accordion">
          <!-- ===== DATOS GENERALES ===== -->
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title><mat-icon>person</mat-icon>DATOS GENERALES</mat-panel-title>
            </mat-expansion-panel-header>

            <div class="panel-content">
              <div class="datos-block">
                <h3 class="datos-titulo">
                  <mat-icon>person</mat-icon>DATOS PERSONALES
                </h3>

                <div class="grid-3">
                  <!-- NOMBRE -->
                  <div class="datos-item">
                    <span class="datos-label">NOMBRE</span>
                    <span class="datos-valor">
                      {{ patient.nombres }} {{ patient.primerApellido }} {{ patient.segundoApellido }}
                    </span>
                  </div>

                  <!-- EDAD -->
                  <div class="datos-item">
                    <span class="datos-label">EDAD</span>
                    <span class="datos-valor">{{ patient.edad }} AÑOS</span>
                  </div>

                  <!-- NACIMIENTO -->
                  <div class="datos-item">
                    <span class="datos-label">NACIMIENTO</span>
                    <span class="datos-valor">{{ patient.fechaNacimiento }}</span>
                  </div>

                  <!-- GENERO BIOLOGICO -->
                  <div class="datos-item">
                    <span class="datos-label">GÉNERO BIOLÓGICO</span>
                    <span class="datos-valor">
                      {{
                                      patient.genero === 'F'
                                        ? 'FEMENINO'
                                        : (patient.genero === 'M'
                                          ? 'MASCULINO'
                                          : (patient.genero || 'NO ESPECIFICADO'))
                                    }}
                    </span>
                  </div>

                  <!-- GENERO VISIBLE -->
                  <div class="datos-item">
                    <span class="datos-label">IDENTIDAD DE GÉNERO</span>
                    <span class="datos-valor">
                      {{ patient.generoVisible || 'NO ESPECIFICADO' }}
                    </span>
                  </div>
                </div>
              </div>

              <hr class="section-divider" />

              <div class="datos-block">
                <h3 class="datos-titulo"><mat-icon>contact_mail</mat-icon>CONTACTO Y DOMICILIO</h3>
                <div class="grid-2">
                  <div class="datos-item">
                    <span class="datos-label">CORREO</span>
                    <span class="datos-valor break-anywhere">{{ patient.email }}</span>
                  </div>
                  <div class="datos-item">
                    <span class="datos-label">TELEFONO</span>
                    <span class="datos-valor">{{ patient.movil | formatMobile }}</span>
                  </div>
                  <div class="datos-item full-width">
                    <span class="datos-label">DIRECCION</span>
                    <span class="datos-valor">
                      {{ patient.domicilio }}, {{ patient.codigoPostal }}, {{ patient.asentamiento }}, {{ patient.municipio }}, {{ patient.estado }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </mat-expansion-panel>

          <!-- ===== DIAGNOSTICO ===== -->
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title><mat-icon>medical_information</mat-icon>DIAGNOSTICO</mat-panel-title>
            </mat-expansion-panel-header>

            <div class="panel-content">
              <div class="row">
                <div class="col-md-4 diagnosis-column">
                  <h3 class="diagnosis-title"><mat-icon>coronavirus</mat-icon>PATOLOGIAS</h3>
                  <mat-list class="scroll-list">
                    <div *ngIf="!patient.patologias?.length" class="empty-list-message">NO HAY DATOS</div>
                    <mat-list-item *ngFor="let row of patient.patologias">
                      <span class="list-item-text">{{ row.nameCIM10 }}</span>
                    </mat-list-item>
                  </mat-list>
                </div>

                <div class="col-md-4 diagnosis-column">
                  <h3 class="diagnosis-title"><mat-icon>warning</mat-icon>ALERGIAS</h3>
                  <mat-list class="scroll-list">
                    <div *ngIf="!patient.alergias?.length" class="empty-list-message">NO HAY DATOS</div>
                    <mat-list-item *ngFor="let row of patient.alergias">
                      <span class="list-item-text">{{ row.nameAllergy }}</span>
                    </mat-list-item>
                  </mat-list>
                </div>

                <div class="col-md-4 diagnosis-column">
                  <h3 class="diagnosis-title"><mat-icon>science</mat-icon>MOLECULAS</h3>
                  <mat-list class="scroll-list">
                    <div *ngIf="!patient.molecules?.length" class="empty-list-message">NO HAY DATOS</div>
                    <mat-list-item *ngFor="let row of patient.molecules">
                      <span class="list-item-text">{{ row.nameMolecule }}</span>
                    </mat-list-item>
                  </mat-list>
                </div>
              </div>
            </div>
          </mat-expansion-panel>

          <!-- ===== MEDICAMENTOS ACTIVOS ===== -->
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon>medication</mat-icon>MEDICAMENTOS ACTIVOS
                <span class="count-chip ml-8" *ngIf="(medicamentosActivosPaciente?.length ?? 0) > 0">
                  {{ medicamentosActivosPaciente.length }}
                </span>
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="panel-content">

              <!-- ✅ Banner si hay ocultos pero NO se han mostrado -->
              <div class="rx-hidden-banner" *ngIf="hasHiddenMeds && !showHiddenMeds">
                <div class="rx-hidden-text">
                  <mat-icon class="rx-hidden-icon">visibility_off</mat-icon>
                  <span>EL PACIENTE TIENE MEDICAMENTOS OCULTOS</span>
                </div>

                <button
                  mat-stroked-button
                  color="primary"
                  type="button"
                  (click)="toggleMedicamentosOcultos()">
                  <mat-icon>visibility</mat-icon>
                  MOSTRAR MEDICAMENTOS OCULTOS
                </button>
              </div>

              <!-- Loading -->
              <div class="rx-empty" *ngIf="isLoadingMedsActivos">
                <mat-icon class="rx-empty-icon">hourglass_top</mat-icon>
                <span>CARGANDO MEDICAMENTOS ACTIVOS...</span>
              </div>

              <!-- Empty -->
              <div class="rx-empty" *ngIf="!isLoadingMedsActivos && (medicamentosActivosPaciente?.length ?? 0) === 0">
                <mat-icon class="rx-empty-icon">info</mat-icon>
                <span>NO HAY MEDICAMENTOS ACTIVOS REGISTRADOS.</span>
              </div>

              <!-- List -->
              <div class="rx-list" *ngIf="!isLoadingMedsActivos && (medicamentosActivosPaciente?.length ?? 0) > 0">
                <div
                  class="rx-item"
                  *ngFor="let m of medicamentosActivosPaciente; trackBy: trackMedActivo"
                >
                  <div class="rx-item-title">

                    <!-- 🔒 Si está oculto y NO se ha ingresado PIN -->
                    <ng-container *ngIf="m?.hide && !showHiddenMeds; else showName">
                      <mat-icon class="rx-lock-icon">lock</mat-icon>
                      <span class="rx-hidden-text-item">MEDICAMENTO OCULTO</span>
                    </ng-container>

                    <!-- ✅ Nombre + badge OCULTO si venía oculto -->
                    <ng-template #showName>
                      <span>{{ m?.medicamento }}</span>
                    </ng-template>

                  </div>

                  <!-- Meta solo si no está bloqueado -->
                  <div class="rx-item-meta" *ngIf="!(m?.hide && !showHiddenMeds)">
                    <span class="rx-pill">
                      <mat-icon class="rx-pill-icon">inventory_2</mat-icon>
                      <strong>{{ m?.drugType | medicamentoTypeLabel }}</strong>
                    </span>

                    <span class="rx-pill rx-pill-muted">
                      <mat-icon class="rx-pill-icon">event</mat-icon>
                      <span>FECHA:</span>
                      <strong>{{ formatFechaCorta(m?.fechaCreacion) }}</strong>
                    </span>

                    <!-- ✅ Identificador visual del que era oculto (aunque ya se vea por PIN) -->
                    <span class="rx-badge-hidden" *ngIf="m?.hide">
                        <mat-icon class="rx-badge-hidden-icon">visibility_off</mat-icon>
                        OCULTO
                      </span>
                  </div>
                </div>
              </div>

            </div>
          </mat-expansion-panel>

          <!-- ✅ PERSONAS A CARGO -->
          <mat-expansion-panel *ngIf="isTutor" [expanded]="false">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon>groups</mat-icon>PERSONAS A CARGO
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="panel-content">
              <div class="tutorados-toolbar">
                <div class="tutorados-toolbar-left">
                  <span class="count-chip">{{ tutorados.length }}</span>
                  <span class="tutorados-toolbar-title">PACIENTE(S) ASIGNADO(S)</span>
                </div>
              </div>

              <div class="tutorados-grid">
                <div *ngFor="let row of tutorados" class="tutorado-card">
                  <!-- Header -->
                  <div class="tutorado-header">
                    <div class="tutorado-header-row">
                      <img
                        class="avatar avatar--sm"
                        [src]="getTutoradoImageSrc(row)"
                        alt="Foto del Paciente"
                      />

                      <div class="tutorado-header-text">
                        <div class="tutorado-name">{{ getTutoradoNombre(row) || 'SIN NOMBRE' }}</div>

                        <div class="tutorado-badges">
                          <span class="badge" *ngIf="row?.fechaNacimiento">
                            <mat-icon>cake</mat-icon>
                            <span>NAC: {{ row.fechaNacimiento | date:'yyyy-MM-dd' }}</span>
                          </span>

                          <span class="badge" *ngIf="row?.genero">
                            <mat-icon>person</mat-icon>
                            <span>{{ row.genero === 'F' ? 'FEMENINO' : (row.genero === 'M' ? 'MASCULINO' : row.genero) }}</span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Body -->
                  <div class="tutorado-body">
                    <div class="meta-row" *ngIf="row?.email">
                      <mat-icon>email</mat-icon>
                      <span class="meta-text break-anywhere">{{ row.email }}</span>
                    </div>

                    <div class="meta-row" *ngIf="row?.movil">
                      <mat-icon>phone</mat-icon>
                      <span class="meta-text">{{ row.movil | formatMobile }}</span>
                    </div>

                    <div class="meta-row" *ngIf="row?.domicilio">
                      <mat-icon>location_on</mat-icon>
                      <span class="meta-text">{{ row.domicilio }}</span>
                    </div>
                  </div>
                </div>

                <div *ngIf="!tutorados.length" class="empty-list-message" style="height:auto;padding:16px;">
                  NO HAY PACIENTES A CARGO
                </div>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>

        <div class="card">
          <div class="card-header"><h2 class="card-title">RECETAS</h2></div>
          <div class="card-body">
            <app-prescription-by-id-patient
              [param]="param!"
              [embeddedInProfile]="true">
            </app-prescription-by-id-patient>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
